import { render, staticRenderFns } from "./noor-ghiab.vue?vue&type=template&id=eb6b576c&"
import script from "./noor-ghiab.vue?vue&type=script&lang=js&"
export * from "./noor-ghiab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports